import { Injectable, inject } from '@angular/core';
import {ActivatedRouteSnapshot} from '@angular/router';
import {JobDetail} from '../interfaces/job-detail';
import {Observable} from 'rxjs';
import {JobboardAdapter} from '../adapters/jobboard.adapter';

@Injectable({
  providedIn: 'root',
})
export class JobResolver {
  private adapter = inject(JobboardAdapter);

  resolve(route: ActivatedRouteSnapshot): Observable<JobDetail> {
    return this.adapter.getJob(route.params['jobId']);
  }
}
